module.exports = __webpack_public_path__ + "img/background.75bac323.png";